/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit DownloadAction.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromFlow from 'Logic/ViewsFlow.js'
import Download from 'DesignSystem/Svgs/Download/view.js'
import DropdownChoicesIconOption from 'DesignSystem/DropdownChoicesIconOption/view.js'
import React from 'react'



export default function DownloadAction({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  isSelected,
viewPath= "/App/MyAccount/Content/Profile/Content/Individuals/MoreActions/Content/DownloadCSV/DownloadAction",
isHovered
}) {
    
    
    
    let flow = fromFlow.useFlow()
let setFlowTo = fromFlow.useSetFlowTo(viewPath)
    
    

  return (<React.Fragment
>
<DropdownChoicesIconOption
 data-testid="DownloadAction.DropdownChoicesIconOption"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/MoreActions/Content/DownloadCSV/DownloadAction"
viewPath={`${viewPath}/DropdownChoicesIconOption`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/Individuals/MoreActions/Content/DownloadCSV/Processing")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/Individuals/MoreActions/Content/DownloadCSV/Processing")}
 text="Download CSV"
 paddingTop={8}
 paddingBottom={8}
 paddingLeft={8}
 justifyContent="flex-start"
>
{childProps => (
<Download
{...childProps}
 data-testid="DownloadAction.Download"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/MoreActions/Content/DownloadCSV/DownloadAction"
viewPath={`${viewPath}/Download`}
 width={18}
 height={18}
 stroke={childProps.isSelected ? "rgb(0,162,255)" : childProps.isHovered ? "rgb(0,162,255)" : "#606060"}
/>
)}
</DropdownChoicesIconOption>
{children}
</React.Fragment>)
}